import { render, staticRenderFns } from "./advertVedioView.vue?vue&type=template&id=8d7a02da&scoped=true"
import script from "./advertVedioView.vue?vue&type=script&lang=js"
export * from "./advertVedioView.vue?vue&type=script&lang=js"
import style0 from "./advertVedioView.vue?vue&type=style&index=0&id=8d7a02da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7a02da",
  null
  
)

export default component.exports